import React, { lazy } from 'react';
import Loadable from 'app/components/Loadable';
import { authRoles } from 'app/auth/authRoles';

const Viewer = Loadable(lazy(() => import('./Viewer')));
const AutodeskAuthCallback = Loadable(lazy(() => import('./AutodeskAuthCallback')));
const APSAuthError = Loadable(lazy(() => import('./APSAuthError')));

const viewerRoutes = [
    {
        path: '/viewer',
        element: <Viewer />,
        auth: authRoles.user,
    },
    {
        path: '/viewer/callback',
        element: <AutodeskAuthCallback />,
    },
    {
        path: '/viewer/error',
        element: <APSAuthError />,
    },
];

export default viewerRoutes;
